import React from 'react';

import { TrendBlocLoader } from 'modules/shared-cms-advanced/components';
import { ProductThumbnailLoader } from 'modules/catalogue/components';

import styles from './tendance-catalogue-component.module.css';

export const TendanceCatalogueLoader: React.FC = React.memo(() => {
    return (
        <div className={styles.trendBloc}>
            <TrendBlocLoader>
                <ProductThumbnailLoader />
                <ProductThumbnailLoader />
                <ProductThumbnailLoader />
                <ProductThumbnailLoader />
            </TrendBlocLoader>
        </div>
    );
});
